import React from 'react';

import CloseIcon from '@mui/icons-material/Close';
import { Modal as MuiModal, Box, Button, IconButton } from '@mui/material';

import { AppTypography } from '~components/ui/typography/app-typography';

import { useConfirmationModal } from '~hooks/use-confirmation-modal';

export const ConfirmationModal: React.FC = () => {
  const { activeModal, closeConfirmationModal } = useConfirmationModal();

  const handleConfirm = () => {
    activeModal?.onConfirm?.();
    closeConfirmationModal();
  };

  const handleCancel = () => {
    activeModal?.onCancel?.();
    closeConfirmationModal();
  };

  if (!activeModal) return null;

  const isDanger = activeModal.type !== 'default';
  const isActionsColumn = activeModal.actionsDirection === 'column';

  return (
    <MuiModal open onClose={handleCancel}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          minWidth: 320,
          boxSizing: 'border-box',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 3,
          borderRadius: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
        }}
      >
        <IconButton
          onClick={handleCancel}
          sx={{ position: 'absolute', top: 8, right: 8 }}
        >
          <CloseIcon />
        </IconButton>

        {activeModal.title && (
          <AppTypography size="body-lg" weight="semibold" color="fog.25">
            {activeModal.title}
          </AppTypography>
        )}

        <AppTypography size="body-md" color="fog.35" mb={1}>
          {activeModal.content}
        </AppTypography>

        <Box
          sx={{
            display: 'flex',
            justifyContent: {
              xs: 'flex-start',
              sm: 'flex-end',
            },
            columnGap: 1.5,
            rowGap: 1,
            flexDirection: isActionsColumn
              ? 'column'
              : {
                  xs: 'column',
                  sm: 'row',
                },
          }}
        >
          {activeModal.cancelButton ? (
            <Box
              role={'button'}
              onClick={handleCancel}
              sx={{
                display: 'inline-flex',
                width: isActionsColumn ? '100%' : 'auto',
              }}
            >
              {activeModal.cancelButton}
            </Box>
          ) : (
            <Button onClick={handleCancel} variant="contained" size="small">
              Скасувати
            </Button>
          )}

          {activeModal.confirmButton ? (
            <Box
              role={'button'}
              onClick={handleConfirm}
              sx={{
                display: 'inline-flex',
                width: isActionsColumn ? '100%' : 'auto',
              }}
            >
              {activeModal.confirmButton}
            </Box>
          ) : (
            <Button
              onClick={handleConfirm}
              variant="outlined"
              color={isDanger ? 'error' : 'primary'}
              size="small"
            >
              {isDanger ? 'Видалити' : 'Прийняти'}
            </Button>
          )}
        </Box>
      </Box>
    </MuiModal>
  );
};
